import { authHeader, BASE_URL, handleResponse, handleResponseBlob } from '@helpers/api';

export const analyticsService = {
    getAnalyticsConversion,
    exportAnalyticsCSV,
    getAnalyticsReviews,
    getAnalyticsFeedback,
    getAnalyticsConversations,
    getAnalyticsSocialPosts,
    getAnalyticsPresence,
};

function getAnalyticsConversion(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/analytics/conversion`, requestOptions).then(handleResponse);
}

function exportAnalyticsCSV(query, type, params) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(query),
    };
    const queryString = params ? `?graph=${params}` : '';
    return fetch(`${BASE_URL}api/analytics/${type}/export${queryString}`, requestOptions).then(handleResponseBlob);
}

function getAnalyticsReviews(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/analytics/reviews`, requestOptions).then(handleResponse);
}

function getAnalyticsFeedback(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/analytics/feedbacks`, requestOptions).then(handleResponse);
}

function getAnalyticsConversations(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/analytics/conversations`, requestOptions).then(handleResponse);
}

function getAnalyticsSocialPosts(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/analytics/social-posts`, requestOptions).then(handleResponse);
}

function getAnalyticsPresence(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/analytics/presence`, requestOptions).then(handleResponse);
}
